import { AfterViewInit, Component, OnInit, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SecurityService } from '../../services/security.service';
import { environment } from '@env/environment';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../services/loader.service';
import {
  clearInvalidCredentialsReloadFlag,
  isInvalidCredentialsError,
  recoverFromInvalidCredentials,
} from '../../shared/utils/invalid-credentials.utils';

@Component({
  selector: 'app-home',
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {

  colorOne = environment.colorOne;
  colorTwo = environment.colorTwo;
  webVersion = localStorage.getItem('version');

  internalCode: string | null = null;
  consultor = signal<any | null>(null);
  nextRoute = '/app/basic';
  isLightVersion = signal(false);

  constructor(
    private title: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private securityService: SecurityService,
    private _loaderService: LoaderService

  ) {
    this.title.setTitle('Onboarding Digital | Inicio');
    this.internalCode = this.activatedRoute.snapshot.paramMap.get('internalCode');

    this.detectLightVersion();
  }

  async ngOnInit() {
    const route = localStorage.getItem('route');
    const currentUrl = this.router.url;
    if(route && currentUrl !== route && this.isValidRoute(route)) {
      await this.router.navigateByUrl(route);
    } else {
      if(route && !this.isValidRoute(route)) {
        localStorage.removeItem('route');
      }
      if (this.internalCode != null) {
        this.loadConsultorByInternalCode(this.internalCode);
      } else if (localStorage.getItem('consultor')) {
        this.loadConsultorFromSession();
      }
    }
  }

  ngAfterViewInit(): void {
    this._loaderService.hide();
  }

  private detectLightVersion(): void {
    const currentUrl = this.router.url;
    const isLightRoute = currentUrl.includes('/light/');

    if (isLightRoute) {
      localStorage.setItem('lightVersion', 'true');
      this.isLightVersion.set(true);
    } else {
      const currentLightVersion = localStorage.getItem('lightVersion');
      if (currentLightVersion === 'true') {
        localStorage.removeItem('lightVersion');
      }
      this.isLightVersion.set(false);
    }
  }

  private isValidRoute(route: string): boolean {
    const hasSession = localStorage.getItem('session');
    const hasConsultor = localStorage.getItem('consultor');

    if(!hasSession || !hasConsultor) {
      localStorage.removeItem('route');
      return false;
    }
    return true;
  }

  private loadConsultorByInternalCode(code: string): void {
    this._loaderService.show();
    localStorage.setItem('consultor', code);
    this.securityService.setConsultorUpdatingData(code).subscribe({
      next: (response: any) => {
        clearInvalidCredentialsReloadFlag();
        this.setConsultorData(response);
        this._loaderService.hide();

      },
      error: (error) => {
        if (isInvalidCredentialsError(error) && recoverFromInvalidCredentials()) {
          return;
        }

        console.error('Error loading consultor by internal code:', error);
        this._loaderService.hide();
      }
    });
  }

  private loadConsultorFromSession(): void {
    this._loaderService.show();
    this.securityService.getConsultor().subscribe({
      next: (response: any) => {
        this.setConsultorData(response);
        this._loaderService.hide();

      },
      error: (error) => {
        console.error('No consultor found in session:', error);
        this._loaderService.hide();

      }
    });
  }

  private setConsultorData(data: any): void {
    this.consultor.set({
      ...data,
      qrImage: `${environment.serverUrl}/assets/qr/${data.qrCode}`
    });
  }

  async next() {
    this._loaderService.show();

    let targetRoute = this.nextRoute;
    if (this.isLightVersion()) {
      targetRoute = '/app/basic';
    }

    localStorage.setItem('route', targetRoute);
    this.router.navigateByUrl(targetRoute);
  }

  clearLightVersion(): void {
    localStorage.removeItem('lightVersion');
    this.isLightVersion.set(false);
  }
}
